<template>
  <div>
    <!-- CareerWise -->
    <CWCentralHome v-if="client === 'client1'" />
    <CWTenantHome v-if="client === 'client1tenant'" />
    <CWCloudHome v-if="client === 'client1cloud'" />

    <!-- CareerExpo -->
    <ExpoCentralHome v-if="client === 'client2'" />
    <ExpoTenantHome v-if="client === 'client2tenant'" />
    <ExpoOnlineHome v-if="client === 'client2cloud'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shared } from '../../js/mixins/shared.js'
import ExpoTenantHome from '../../expo/tenant/public/Home.vue'
import CWTenantHome from '../../careerwise/tenant/public/pages/home/HomeWrapper.vue'
import CWCentralHome from '../../careerwise/central/pages/Home.vue'
import ExpoCentralHome from '../../expo/central/pages/Home.vue'
import CWCloudHome from '../../careerwise/cloud/pages/Home.vue'
import ExpoOnlineHome from '../../expo/online/pages/Home.vue'

export default {
  components: {
    CWTenantHome,
    ExpoTenantHome,
    CWCentralHome,
    ExpoCentralHome,
    CWCloudHome,
    ExpoOnlineHome,
  },

  mixins: [shared],

  computed: {
    ...mapGetters({
      client: 'shared/getClient',
    }),
  },
}
</script>
